import { Component, Input } from '@angular/core';

import { RadioModel }           from './typings/radio';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-radio-group',
  styles: [ require('./radio-group.component.scss') ],
  template: require('./radio-group.component.html')
})
export class RadioGroupComponent extends TextControlComponent {
  _options : Array<RadioModel> = [];

  @Input() set options ( _options : Array<RadioModel> ) {
    this._options = _options.map(( option : RadioModel, index : number ) => {
      option.disabled = !!this._disabled || !!option.disabled;

      option.order = option.order || option.order === 0
        ? option.order
        : index;

      option.type = option.type || 'normal';

      return option;
    })
    .sort((a, b) => a.order - b.order);
  }

  getRadioClasses ( option : RadioModel ) : Array<string> {
    const classes : Array<string> = [];

    switch (option.type) {
      case 'danger':
        classes.push('radio-danger');
        break;
      case 'success':
        classes.push('radio-success');
        break;
      case 'warning':
        classes.push('radio-warning');
        break;
      case 'normal':
      default:
        break;
    }

    return classes;
  }
}
